import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { eventsApi } from 'src/Services/API';

/**
 * Fetches all events for the current asset (no date range, no recurrence expansion).
 * Returns a simple list of { id, name } for use in selectors.
 */
const useFetchAllEvents = () => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: ['fetch-all-events', assetId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');
      const response = await eventsApi.eventsControllerList(assetId);
      return response.data;
    },
    enabled: !!assetId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export default useFetchAllEvents;
